// removed by extract-text-webpack-plugin
module.exports = {"featureSection":"src-components-Epilogue----Epilogue-module---featureSection---2fuyZ","featureBox":"src-components-Epilogue----Epilogue-module---featureBox---1y70R","alternate":"src-components-Epilogue----Epilogue-module---alternate---iiF69","featureImageBox":"src-components-Epilogue----Epilogue-module---featureImageBox---1cG4v","credit":"src-components-Epilogue----Epilogue-module---credit---219Op","featureFullscreenBackground":"src-components-Epilogue----Epilogue-module---featureFullscreenBackground---1Iopk","innerBox":"src-components-Epilogue----Epilogue-module---innerBox---alb9W"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Epilogue/Epilogue.module.scss
// module id = 266
// module chunks = 221374088121123